<template>
	<IntContentSection :padding-top="false" :padding-bottom="false" background="primary">
		<IntContentContainer :padding-x="false" class="px-6 md:px-0">
			<div ref="tnsContainer" class="grid grid-cols-1 overflow-hidden md:grid-cols-2">
				<slot></slot>
			</div>
		</IntContentContainer>
	</IntContentSection>
</template>

<script>
import { tns } from "tiny-slider"
import "tiny-slider/dist/tiny-slider.css"

import IntContentContainer from "../content-container"
import IntContentSection from "../content-section"

export default {
	name: "IntInfoBanner",

	components: { IntContentContainer, IntContentSection, tns },

	data() {
		return {
			tnsInstance: null,
		}
	},

	mounted() {
		this.tnsInstance = tns({
			autoplay: true,
			autoplayButtonOutput: false,
			autoplayHoverPause: true,
			container: this.$refs.tnsContainer,
			controls: false,
			mode: "gallery",
			nav: false,
			responsive: {
				768: {
					items: 2,
				},
			},
			touch: false,
		})
	},
}
</script>
